import { render, staticRenderFns } from "./synergyAISidebar.vue?vue&type=template&id=62e4b01c&scoped=true&"
import script from "./synergyAISidebar.vue?vue&type=script&lang=js&"
export * from "./synergyAISidebar.vue?vue&type=script&lang=js&"
import style0 from "./synergyAISidebar.vue?vue&type=style&index=0&id=62e4b01c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e4b01c",
  null
  
)

export default component.exports